import styled from "styled-components";
import { theme } from "../../theme";

export const StyledForgotPasswordCard = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: fit-content;
  min-width: 40%;
  margin: 0 auto;
  border: 2px solid ${theme.textColor.primaryGray};
  padding: 24px;
  align-self: center;
  button {
    width: 100%;
    margin: 0 0 16px 0;
  }
  small {
    color: ${theme.textColor.secondaryGray};
    float: right;
    display: block;
    margin-left: auto;
    margin-bottom: 16px;
    cursor: pointer;
    font-weight: 500;
    &:hover {
      color: ${theme.textColor.primaryBlack};
    }
  }
  span {
    color: ${theme.textColor.secondaryGray};
    float: right;
    display: block;
    margin: auto;
    cursor: pointer;
    font-weight: 500;
    a {
      color: ${theme.textColor.primaryBlack};
      font-weight: 700;
      text-decoration: none;
    }
    &:hover {
      color: ${theme.textColor.primaryBlack};
    }
  }
  @media (max-width: 990px) {
    width: 80%;
    padding: 16px;
  }
`;
